// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".yPH34Wsxpfpd7o {\n  position: relative;\n  overflow-y: auto;\n  outline: none;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popoverBoundary": "yPH34Wsxpfpd7o"
};
export default ___CSS_LOADER_EXPORT___;
